/** Type used for @see Request.method. */
export enum HttpMethod {
  delete = 'DELETE',
  get = 'GET',
  post = 'POST',
  put = 'PUT'
}
